import {ReactElement} from 'react';

import './index.css';

interface FormatterResult {
  component: ReactElement;
}

type Formatter = (value: string) => FormatterResult;

const defaultListFormatter: Formatter = value => {
  return {
    component: <span dangerouslySetInnerHTML={{__html: value}} />,
  };
};

export const formatters: Record<string, Formatter> = {
  label: defaultListFormatter,
  value: defaultListFormatter,
};
